<!--
 * @Author: Axs <i@axs.email>
 * @Date: 2020-08-04 18:48:05
 * @LastEditors: Axs <i@axs.email>
 * @LastEditTime: 2020-09-02 11:56:58
 * @Description: 
 * @FilePath: /src/page/map/index.vue
-->
<template>
    <div class="page map" id="map"></div>
</template>
<script type="text/javascript">
window._AMapSecurityConfig = {
    // securityJsCode: '69c8fb6d1f688eeae7073f611778c667',
};
</script>
<script>
export default {
    data() {
        return {
            url: '',
        };
    },
    computed: {
        lon() {
            return this.$route.query.lon || 0;
        },
        lat() {
            return this.$route.query.lat || 0;
        },
        cinemaName() {
            return this.$route.query.cinemaName || '';
        },
        cinemaAddress() {
            return this.$route.query.cinemaAddress || '';
        },
    },
    created() {
        this.$util.dynamicLoadJs('https://webapi.amap.com/loader.js', () => {
            AMapLoader.reset();
            AMapLoader.load({
                // key: '3ee4bcf8c99fc1bfe930857af29ad5d1', // 申请好的Web端开发者Key，首次调用 load 时必填
                version: '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
            }).then(AMap => {
                const map = new AMap.Map('map', {
                    viewMode: '2D', // 默认使用 2D 模式
                    zoom: 16, //初始化地图层级
                    center: [this.lon, this.lat], //初始化地图中心点
                });

                const markerDit = new AMap.Marker({
                    position: new AMap.LngLat(this.lon, this.lat),
                    content: `<div class="cinema-dit"></div>`, // 将 html 传给 content
                    offset: new AMap.Pixel(0, 0), // 以 icon 的 [center bottom] 为原点
                });

                const markerName = new AMap.Marker({
                    position: new AMap.LngLat(this.lon, this.lat),
                    content: `
                    <div class="cinema-name-line">
                        <div class="cinema-name">${this.cinemaName}</div>
                    </div>`, // 将 html 传给 content
                    offset: new AMap.Pixel(0, 0), // 以 icon 的 [center bottom] 为原点
                });

                map.add(markerDit);
                map.add(markerName);
            });
        });
    },
    methods: {},
};
</script>

<style lang="less" scoped>
.map {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
    height: 100vh;
}
</style>
<style lang="less">
@import url('~@/lib/base.less');
.map {
    .cinema-dit {
        width: .pxToRem(12) [];
        height: .pxToRem(12) [];
        border-radius: 100%;
        background: @theme_color_first;
        border: .pxToRem(4) [] solid red;
        transform: translate(-50%, -50%);
    }
    .cinema-name-line {
        width: 100vw;
        transform: translate(-50%);
        text-align: center;
    }
    .cinema-name {
        display: inline-block;
        max-width: .pxToRem(400) [];
        transform: translate(0%);
        padding: .pxToRem(8) [];
        margin-top: .pxToRem(24) [];
        border-radius: .pxToRem(8) [];
        border: .pxToRem(2) [] solid @theme_color_first;
        background-color: rgba(255, 255, 255, 0.9);
        color: rgba(0, 0, 0, 0.9);
        z-index: 1;
    }
    .cinema-name::after {
        content: ' ';
        .base-center-x;
        top: .pxToRem(-8) [];
        width: .pxToRem(12) [];
        height: .pxToRem(12) [];
        background-color: rgba(255, 255, 255, 0.9);
        transform: translateX(-50%) rotate(45deg);
        border-top: .pxToRem(2) [] solid @theme_color_first;
        border-left: .pxToRem(2) [] solid @theme_color_first;
        z-index: -2;
    }
}
</style>
